import React from 'react';
import { ReactTyped } from 'react-typed';
import { HashLink } from 'react-router-hash-link';

const Hero = () => {
  return (
    <div className="w-full h-screen relative overflow-hidden">
      <div>
        <div className="bg-landingimage bg-cover h-screen w-screen -z-10"></div>
        <div className="absolute top-0 left-0 w-full h-screen bg-black bg-opacity-20 text-white flex content-center justify-center">
          <div className="text-center flex flex-col justify-center">
            <h1 className="md:text-5xl sm:text-4xl text-2xl font-bold drop-shadow-lg pt-20">
              Jacksonville's
            </h1>
            <p className="md:text-7xl sm:text-6xl text-4xl font-bold md:py-9 drop-shadow-lg ">
              Most Trusted
            </p>
            <div className="flex justify-center items-center text-[#0098D1]">
              <ReactTyped
                className="md:text-5xl sm:text-4xl text-xl font-bold md:pl-4 pl-2"
                strings={[
                  'AC Repair Experts',
                  'Heating Specialists',
                  'HVAC Professionals',
                ]}
                typeSpeed={80}
                backSpeed={100}
                loop
              />
            </div>
            <HashLink to="/#Contact">
              <button className="bg-[#FD6721] w-[200px] rounded-md font-medium my-20 mx-auto py-3 text-black shadow-sm shadow-black hover:bg-blue-600">
                Free Quote
              </button>
            </HashLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
